import api from '../../../services/api';

export const installmentService = {
  list: () => api.get('/installments'),
  upsert: (data: { id?: string; description: string; months: Record<string, number> }) =>
    api.post('/installments', data),
  remove: (id: string) => api.delete(`/installments/${id}`),
};
